export default function IconTagsSearch({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <g id="Tags-Search Streamline Ultimate" clipPath="url(#clip0_0_65)">
        <path
          id="Vector"
          d="M12.4071 6.78825L13.7571 5.4105C14.0716 5.05317 14.2565 4.60032 14.2821 4.125V1.125C14.2821 0.926088 14.2031 0.735322 14.0624 0.59467C13.9218 0.454018 13.731 0.375 13.5321 0.375L10.3386 0.38025C9.86392 0.406615 9.41237 0.593902 9.05836 0.91125L0.937363 9.03225C0.79676 9.1729 0.717773 9.36363 0.717773 9.5625C0.717773 9.76137 0.79676 9.9521 0.937363 10.0927L4.56436 13.7197C4.63375 13.7891 4.7162 13.8441 4.80695 13.8814C4.89771 13.9187 4.99496 13.9377 5.09308 13.9372C5.19121 13.9367 5.28827 13.9168 5.37864 13.8786C5.46902 13.8403 5.55092 13.7846 5.61961 13.7145L6.40711 12.9105L12.4071 6.78825ZM11.6571 4.125C11.4346 4.125 11.2171 4.05902 11.0321 3.9354C10.8471 3.81179 10.7029 3.63609 10.6177 3.43052C10.5326 3.22495 10.5103 2.99875 10.5537 2.78052C10.5971 2.56229 10.7043 2.36184 10.8616 2.2045C11.019 2.04717 11.2194 1.94003 11.4376 1.89662C11.6559 1.85321 11.8821 1.87549 12.0876 1.96064C12.2932 2.04578 12.4689 2.18998 12.5925 2.37498C12.7161 2.55999 12.7821 2.7775 12.7821 3C12.7821 3.29837 12.6636 3.58452 12.4526 3.7955C12.2416 4.00647 11.9555 4.125 11.6571 4.125Z"
          fill="#D4B4FA"
        />
        <path
          id="Vector_2"
          d="M2.75011 11.9062L10.8614 3.795C10.6646 3.58154 10.558 3.30029 10.5638 3.01004C10.5696 2.7198 10.6874 2.44303 10.8925 2.23761C11.0977 2.03219 11.3742 1.91402 11.6645 1.9078C11.9547 1.90159 12.2361 2.0078 12.4499 2.20425L14.0616 0.594C13.9211 0.453797 13.7306 0.375042 13.5321 0.375L10.3386 0.38025C9.86392 0.406615 9.41237 0.593902 9.05836 0.91125L0.937363 9.03225C0.79676 9.1729 0.717773 9.36363 0.717773 9.5625C0.717773 9.76137 0.79676 9.9521 0.937363 10.0927L2.75011 11.9062Z"
          fill="#F9F5FE"
        />
        <path
          id="Vector_3"
          d="M11.3414 7.875L13.7564 5.4105C14.0709 5.05317 14.2558 4.60032 14.2814 4.125V1.125C14.2814 0.926088 14.2024 0.735322 14.0617 0.59467C13.9211 0.454018 13.7303 0.375 13.5314 0.375L10.3379 0.37875C9.86311 0.404759 9.41144 0.592093 9.05763 0.90975L0.936631 9.03075C0.796028 9.1714 0.717041 9.36213 0.717041 9.561C0.717041 9.75987 0.796028 9.9506 0.936631 10.0912L4.56363 13.7183C4.63302 13.7876 4.71547 13.8426 4.80622 13.8799C4.89697 13.9172 4.99422 13.9362 5.09235 13.9357C5.19048 13.9352 5.28753 13.9153 5.37791 13.8771C5.46829 13.8388 5.55019 13.7831 5.61888 13.713L7.29888 12M11.6564 4.125C11.4339 4.125 11.2164 4.05902 11.0314 3.9354C10.8464 3.81179 10.7022 3.63609 10.617 3.43052C10.5319 3.22495 10.5096 2.99875 10.553 2.78052C10.5964 2.56229 10.7036 2.36184 10.8609 2.2045C11.0182 2.04717 11.2187 1.94003 11.4369 1.89662C11.6551 1.85321 11.8813 1.87549 12.0869 1.96064C12.2925 2.04578 12.4682 2.18998 12.5918 2.37498C12.7154 2.55999 12.7814 2.7775 12.7814 3C12.7814 3.29837 12.6629 3.58452 12.4519 3.7955C12.2409 4.00647 11.9547 4.125 11.6564 4.125Z"
          stroke="#651AA9"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M9.03149 12.7707C9.03149 13.6715 9.38936 14.5355 10.0264 15.1725C10.6634 15.8095 11.5274 16.1674 12.4282 16.1674C13.3291 16.1674 14.1931 15.8095 14.8301 15.1725C15.4671 14.5355 15.825 13.6715 15.825 12.7707C15.825 11.8698 15.4671 11.0058 14.8301 10.3688C14.1931 9.73177 13.3291 9.3739 12.4282 9.3739C11.5274 9.3739 10.6634 9.73177 10.0264 10.3688C9.38936 11.0058 9.03149 11.8698 9.03149 12.7707Z"
          fill="#D4B4FA"
        />
        <path
          id="Vector_5"
          d="M14.8309 10.3688C14.5154 10.0534 14.141 9.80317 13.7289 9.63246C13.3168 9.46176 12.8751 9.3739 12.429 9.3739C11.9829 9.3739 11.5412 9.46176 11.1291 9.63246C10.717 9.80317 10.3425 10.0534 10.0271 10.3688C9.3901 11.0058 9.03223 11.8698 9.03223 12.7707C9.03223 13.6715 9.3901 14.5355 10.0271 15.1725L14.8309 10.3688Z"
          fill="#F9F5FE"
        />
        <path
          id="Vector_6"
          d="M9.03149 12.7707C9.03149 13.6715 9.38936 14.5355 10.0264 15.1725C10.6634 15.8095 11.5274 16.1674 12.4282 16.1674C13.3291 16.1674 14.1931 15.8095 14.8301 15.1725C15.4671 14.5355 15.825 13.6715 15.825 12.7707C15.825 11.8698 15.4671 11.0058 14.8301 10.3688C14.1931 9.73177 13.3291 9.3739 12.4282 9.3739C11.5274 9.3739 10.6634 9.73177 10.0264 10.3688C9.38936 11.0058 9.03149 11.8698 9.03149 12.7707Z"
          stroke="#651AA9"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_7"
          d="M17.2815 17.6235L14.8455 15.1875"
          stroke="#651AA9"
          strokeWidth="0.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_0_65">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
